import config from 'config';
import { ListPayload, ListResponse } from 'core/http/response';
import axiosClient from '../../config/axios';
import { Currency } from './currency';

export const getCurrencies = (): Promise<ListPayload<Currency>> =>
    axiosClient.get<ListResponse<Currency>>(`${config.cmsUrl}/currency`).then((response) => response.data.payload);
